module.exports = __webpack_public_path__ + "static/media/twitter.e108be91.svg";